import debounce from '../../../../javascripts/helpers/debounce';
import BaseModule from '../../../../javascripts/helpers/baseModule';
import forEach from '../../../../javascripts/dom/forEach';

export default class MainNavigation extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'));

    // prepare a boolean to indicate the status of a function later on (@see windowResize below)
    let executed = false;

    // Handle mobile
    if (this.isMobile()) {
      if (!executed) {
        executed = true;
        this.addEventlisteners();
      }
    } else {
      this.removeEventlisteners();
    }

    const myEfficientFn = debounce(() => {
      if (this.isMobile()) {
        if (!executed) {
          executed = true;
          this.addEventlisteners();
        }
      } else {
        this.removeEventlisteners();
      }
    }, 250);

    window.addEventListener('resize', myEfficientFn);

    if (!this.isMobile()) {
      const navItems = document.querySelectorAll('.m-main-navigation__nav-item-expand');

      navItems.forEach(item => {
        item.removeEventListener('mouseenter', null);
        item.removeEventListener('mouseleave', null);

        // Add click listener to the expand link only
        const expandLink = item.querySelector('.m-main-navigation__nav-item-expand-link');
        expandLink.addEventListener('click', function(e) {
          e.preventDefault();

          navItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('m-main-navigation__nav-item-expand--is-active');
            }
          });

          if (item.classList.contains('m-main-navigation__nav-item-expand--is-active')) {
            item.classList.remove('m-main-navigation__nav-item-expand--is-active');
            document.body.classList.remove('m-main-navigation--open');
          } else {
            item.classList.add('m-main-navigation__nav-item-expand--is-active');
            document.body.classList.add('m-main-navigation--open');
          }
        });

        // Handle close button click
        const closeButton = item.querySelector('.m-main-navigation__nav-item-overview-close');
        if (closeButton) {
          closeButton.addEventListener('click', function(e) {
            e.preventDefault();
            item.classList.remove('m-main-navigation__nav-item-expand--is-active');
            document.body.classList.remove('m-main-navigation--open');
          });
        }
      });

      // Updated document click handler
      document.addEventListener('click', function(e) {
        // Check if the click is inside any of these menu-related elements
        const isInsideMenu = e.target.closest('.m-main-navigation__nav-item-expand') &&
          (e.target.closest('.m-main-navigation__nav-sub-content') ||
           e.target.closest('.m-main-navigation__nav-sub--sub') ||
           e.target.closest('.m-main-navigation__mega-item') ||
           e.target.closest('.m-main-navigation__nav-item-expand-link'));

        if (!isInsideMenu) {
          navItems.forEach(item => item.classList.remove('m-main-navigation__nav-item-expand--is-active'));
          document.body.classList.remove('m-main-navigation--open');
        }
      });


      // Get all the links with the class "m-main-navigation__link"
      const links = document.querySelectorAll('.m-main-navigation__link--with-sub');

      links.forEach(link => {
        link.addEventListener('click', event => {
          // Prevent the default link behavior
          event.preventDefault();

          // Get the parent element of the link
          const parentElement = link.parentNode;
          const megaItemCol = link.parentNode.parentNode.parentNode.querySelector('.m-main-navigation__mega-item-col');

          // Get the sibling element with the class "m-main-navigation__nav-sub--sub"
          const subElement = parentElement.querySelector('.m-main-navigation__nav-sub--sub');

          // Check if the link already has the active class
          if (link.classList.contains('m-main-navigation__link--with-sub--active')) {
            // Remove the active class
            link.classList.remove('m-main-navigation__link--with-sub--active');
            subElement.classList.remove('m-main-navigation__nav-sub--sub--active');
            megaItemCol.classList.remove('m-main-navigation__mega-item-col--open');
            // Reset the height of the expand content
            const expandContent = link.closest('.m-main-navigation__nav-item-expand-content');
            if (expandContent) {
              expandContent.style.height = '';
            }
          } else {
            // Remove the active class from all elements with the class "m-main-navigation__link--with-sub--active"
            document.querySelectorAll('.m-main-navigation__link--with-sub--active').forEach(element => {
              element.classList.remove('m-main-navigation__link--with-sub--active');
            });

            // Remove the active class from all elements with the class "m-main-navigation__nav-sub--sub--active"
            document.querySelectorAll('.m-main-navigation__nav-sub--sub--active').forEach(element => {
              element.classList.remove('m-main-navigation__nav-sub--sub--active');
            });

            // Add the active class
            link.classList.add('m-main-navigation__link--with-sub--active');
            subElement.classList.add('m-main-navigation__nav-sub--sub--active');
            megaItemCol.classList.add('m-main-navigation__mega-item-col--open');

            // Set the height of the parent expand content to match the height of the active submenu
            const expandContent = link.closest('.m-main-navigation__nav-item-expand-content');
            if (expandContent) {
              // Need to wait a tiny bit for the submenu to become visible before measuring
              setTimeout(() => {
                // Get the height of the active submenu
                const submenuHeight = subElement.offsetHeight + 100;

                // Set the height of the expand content
                expandContent.style.height = submenuHeight + 'px';
              }, 10);
            }
          }
        });
      });
    }
  }

  addMobileOpenEvent(event) {
    event.preventDefault();

    this.mobileLangnav = document.querySelector('.m-lang-navigation__lang-mobile');

    event.currentTarget
      .closest('.m-main-navigation__nav-item-expand')
      .classList.add('m-main-navigation__nav-item-expand--active');
    document.body.classList.add('no-overflow');
    // this.mobileLangnav.classList.add('m-lang-navigation__lang-mobile--white');
  }

  addMobileLinkBack(event) {
    this.mobileLangnav = document.querySelector('.m-lang-navigation__lang-mobile');

    event.preventDefault();
    event.currentTarget
      .closest('.m-main-navigation__nav-item-expand')
      .classList.remove('m-main-navigation__nav-item-expand--active');
    document.body.classList.remove('no-overflow');
    // this.mobileLangnav.classList.remove('m-lang-navigation__lang-mobile--white');
  }

  addMobileClose(event) {
    this.mobileLangnav = document.querySelector('.m-lang-navigation__lang-mobile');

    event.preventDefault();
    event.currentTarget
      .closest('.m-main-navigation__nav-item-expand')
      .classList.remove('m-main-navigation__nav-item-expand--active');
    // this.mobileLangnav.classList.remove('m-lang-navigation__lang-mobile--white');
    document.body.classList.toggle('nav-is-toggled');
    document.body.classList.remove('no-overflow');
    document.getElementsByTagName('html')[0].classList.toggle('nav-is-toggled');
  }


  addEventlisteners() {
    this.navExpand = [].slice.call(
      document.querySelectorAll('.m-main-navigation__nav-item-expand')
    );

    forEach(this.navExpand, (i, item) => {
      if (item.childNodes.length < 2) return;

      const navExpandLink = item.querySelector('.m-main-navigation__nav-item-expand-link');

      if (navExpandLink) {
        navExpandLink.addEventListener('click', this.addMobileOpenEvent, false);
      }

      const navBackLink = item.querySelector('.m-main-navigation__nav-item-overview-link-back');
      if (navBackLink) {
        navBackLink.addEventListener('click', this.addMobileLinkBack, false);
      }

      const navCloseLink = item.querySelector('.m-main-navigation__nav-item-overview-close');
      if (navCloseLink) {
        navCloseLink.addEventListener('click', this.addMobileClose, false);
      }
    });

    const mobileClose = document.querySelector('.m-main-navigation__mobile-header-close');
    mobileClose.addEventListener('click', event => {
      event.preventDefault();
      document.body.classList.toggle('nav-is-toggled');
      document.body.classList.remove('no-overflow');
      document.getElementsByTagName('html')[0].classList.toggle('nav-is-toggled');
    });
  }

  removeEventlisteners() {
    this.navExpand = [].slice.call(
      document.querySelectorAll('.m-main-navigation__nav-item-expand')
    );

    forEach(this.navExpand, (i, item) => {
      const navExpandLink = item.querySelector('.m-main-navigation__nav-item-expand-link');
      if (navExpandLink) {
        navExpandLink.removeEventListener('click', this.addMobileOpenEvent, false);
      }

      const navBackLink = item.querySelector('.m-main-navigation__nav-item-overview-link-back');
      if (navBackLink) {
        navExpandLink.removeEventListener('click', this.addMobileLinkBack, false);
      }

      const navCloseLink = item.querySelector('.m-main-navigation__nav-item-overview-close');
      if (navCloseLink) {
        navCloseLink.removeEventListener('click', this.addMobileClose, false);
      }
    });
  }

  isMobile() {
    this.breakpoint = 1280;

    // if window with is smaller than the defined breakpoint value
    if (window.innerWidth < this.breakpoint) {
      return true;
    }
    return false;
  }
}
